const LINE_BREAK_WITH_PADDING_PATTERN = /[ \t\f\v]*\r\n?[ \t\f\v]*|[ \t\f\v]*[\n\u2028\u2029][ \t\f\v]*/g;

function withoutLineBreaks(value) {
  return String(value ?? "").replace(LINE_BREAK_WITH_PADDING_PATTERN, " ");
}

export function normalizeQuerySourceText(value) {
  return withoutLineBreaks(value);
}

export function normalizeQuerySourceCaretIndex(value, caretIndex) {
  const raw = String(value ?? "");
  const source = normalizeQuerySourceText(raw);
  if (!source) {
    return 0;
  }
  const parsed = Number.parseInt(caretIndex, 10);
  const rawOffset = Number.isInteger(parsed)
    ? Math.max(0, Math.min(raw.length, parsed))
    : raw.length;
  const prefix = withoutLineBreaks(raw.slice(0, rawOffset));
  return Math.max(0, Math.min(source.length, prefix.length));
}
